import { useAtomValue } from 'jotai';
import { useMemo } from 'react';
import { useInteractionsAgents } from '@/views/Interactions/hooks/useInteractionsAgents';
import { interactionsAgentsState } from '@/views/Interactions/state/filters';
import {
  buildGroupedAgentOptions,
  parseSelectedAgentIds,
} from './useAgentAutocompleteOptions.helpers';

interface Params {
  stateKey: string;
  /** Raw dropdown input; only drives a request in truncated mode. */
  search?: string;
}

export function useAgentAutocompleteOptions({ stateKey, search = '' }: Params) {
  const selected = useAtomValue(interactionsAgentsState(stateKey));

  const selectedAgentIds = useMemo(
    () => parseSelectedAgentIds(selected),
    [selected],
  );

  const { agents, mode, resultsTruncated, loading, isSearching, truncatedAt } =
    useInteractionsAgents({ search, selectedAgentIds });

  const options = useMemo(() => buildGroupedAgentOptions(agents), [agents]);

  return {
    options,
    mode,
    resultsTruncated,
    isLoading: loading,
    isSearching,
    truncatedAt,
  } as const;
}
